import { ConfirmModalContent } from '@core/modal/modal.service';
import { Action, createAction, props } from '@ngrx/store';
import { IDialogConfig, NotificationType } from '@ra-web-tech-ui-toolkit/components';

export const openCatalogDialog = createAction('[MODAL] Catalog Dialog', props<{ payload: ConfirmModalContent }>());
export const openWebTechDialog = createAction(
  '[MODAL] WebTech Dialog',
  props<{
    config: IDialogConfig;
    notificationType?: NotificationType;
    mainBtnHandler?: () => void;
    closeHandler?: Action;
  }>(),
);
export const closeAllOpenDialogs = createAction('[MODAL] Close All Open Dialogs');
